import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { composeErrorMessage } from "../../utils/utils";
import guestInfoService from "./guestInfoService";

const initialState = {
  guestInfo: null,
  gettingGuestInfo: false,
  errorGettingGuestInfo: ""
};

export const getGuestInfoAction = createAsyncThunk(
  "guestInfo/getGuestInfo",
  async ({ guestId, eventId }, thunkAPI) => {
    try {
      const response = await guestInfoService.getGuestInfo(guestId, eventId);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(composeErrorMessage(error));
    }
  }
);

export const guestInfoSlice = createSlice({
  name: "guestInfo",
  initialState,
  reducers: {
    reset: () => initialState,
    resetError: (state) => {
      state.errorGettingGuestInfo = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGuestInfoAction.pending, (state) => {
        state.gettingGuestInfo = true;
        state.errorGettingGuestInfo = "";
      })
      .addCase(getGuestInfoAction.fulfilled, (state, action) => {
        state.gettingGuestInfo = false;
        state.guestInfo = action.payload;
      })
      .addCase(getGuestInfoAction.rejected, (state, action) => {
        state.gettingGuestInfo = false;
        state.errorGettingGuestInfo = action.payload;
      });
  }
});

export const { reset, resetError } = guestInfoSlice.actions;
export default guestInfoSlice.reducer;
